import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="comment-prompt" (Comments::PromptModalComponent).
export default class extends Controller {
  static targets = ["text", "body"]

  connect() {
    this.modal = this.element.closest(".modal")
    this.focusText = () => this.textTarget.focus()
    this.modal?.addEventListener("shown.bs.modal", this.focusText)

    // Shown once after the action: never restored from the Turbo cache (back button).
    this.discard = () => {
      if (!this.modal) return
      const shown = this.modal.classList.contains("show")
      Modal.getInstance(this.modal)?.dispose()
      this.modal.remove()
      if (shown) {
        document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
        document.body.classList.remove("modal-open")
        document.body.style.removeProperty("overflow")
        document.body.style.removeProperty("padding-right")
      }
    }
    document.addEventListener("turbo:before-cache", this.discard, { once: true })
  }

  disconnect() {
    this.modal?.removeEventListener("shown.bs.modal", this.focusText)
    document.removeEventListener("turbo:before-cache", this.discard)
  }

  // Plain text in, rich text body out: keeps line breaks, escapes the rest.
  submit() {
    const escaped = document.createElement("div")
    escaped.textContent = this.textTarget.value.trim()
    this.bodyTarget.value = `<div>${escaped.innerHTML.replace(/\n/g, "<br>")}</div>`
    // The redirect lands on the same URL and Turbo morphs the page: never under an open modal.
    if (this.modal) Modal.getInstance(this.modal)?.hide()
  }
}
